import MarkdownIt from 'markdown-it';
import markdownItMathjax from 'markdown-it-mathjax';
import mk from 'markdown-it-katex';
import mkl from 'markdown-it-latex';

export const useMarkdown = () => {
	const md = new MarkdownIt({
		html: true,
		linkify: true,
		typographer: true,
	});
	md.use(markdownItMathjax);
	md.use(mk, {
		throwOnError: false,
	});
	md.use(mkl);

	const preprocessLaTeX = (content: string) => {
		if (typeof content !== 'string') {
			return content;
		}
		return content
			.replace(/\\\[(.*?)\\\]/gs, (_, equation) => `$$${equation}$$`)
			.replace(/\\\((.*?)\\\)/gs, (_, equation) => `$$${equation}$$`)
			.replace(/(^|[^\\])\$(.+?)\$/gs, (_, prefix, equation) => `${prefix}$${equation}$`)
			.replace(/\t/g, '\\t');
	};

	// const md = useMemo(() => {

	// }, []);

	const renderMd = (text: string) => {
		text = preprocessLaTeX(text);
		return md.render(text);
	};

	const updateDisplayText = (text: string) => {
		// console.log(text);
		// if (text === '<think>' || text === '</think>') {
		// 	return text;
		// }
		const info: string = renderMd(text);
		const index = info.indexOf('<think>');
		const endIndex = info.indexOf('</think>');
		// console.log('思考部分：', info.substring(index + 7, endIndex), endIndex);
		// console.log('回答部分：', info.substring(endIndex + 8));
		return {
			think: endIndex === -1 ? info : info.substring(index + 7, endIndex),
			content: endIndex === -1 ? '' : info.substring(endIndex + 8),
		};
	};

	return { renderMd: updateDisplayText };
};
